<app-block-wrapper [_editable]="_editable" [style]="style">
  <div
    class="teaser image-{{ assetPosition }}"
    [class.image-out-of-frame]="assetOutOfFrame"
    [class.hide-asset-on-mobile]="hideAssetOnMobile"
    [appStoryblok]="_editable"
  >
    @if (dimensions && asset?.image) {
    <app-picture
      class="br-{{ borderRadius }}"
      [scale]="0.5"
      [class.shadow-box]="shadowBox"
      [url]="asset.image.filename | storyblokCdn"
      [maxWidth]="maxWidth"
      [width]="dimensions.width"
      [height]="dimensions.height"
      [alt]="asset.image.alt || ''"
      [animateInView]="assetPosition"
      [appStoryblok]="asset._editable"
    >
      @if (assetBackground?.filename) {
      <img [src]="assetBackground.filename | storyblokCdn" class="teaser-asset-bg" alt="" />
      }
    </app-picture>
    } @else { @if (dimensions && asset?.video?.filename) {
    <video
      class="br-{{ borderRadius }}"
      #videoEl
      autoplay
      loop
      muted
      playsinline
      disablepictureinpicture="true"
      [class.shadow-box]="shadowBox"
      [width]="dimensions.width"
      [height]="dimensions.height"
      [poster]="asset.poster?.filename | storyblokCdn"
      [appStoryblok]="asset._editable"
    >
      <source [src]="asset.video.filename | storyblokCdn" type="video/mp4" provider="html5" size="1080" />
    </video>
    } @else {
    <div [appStoryblok]="asset?._editable" class="asset-placeholder"></div>
    } }
    <ng-template #video>
      @if (dimensions && asset?.video?.filename) {
      <video
        #videoEl
        autoplay
        loop
        muted
        playsinline
        disablepictureinpicture="true"
        [class.shadow-box]="shadowBox"
        [width]="dimensions.width"
        [height]="dimensions.height"
        [poster]="asset.poster?.filename | storyblokCdn"
        [appStoryblok]="asset._editable"
      >
        <source [src]="asset.video.filename | storyblokCdn" type="video/mp4" provider="html5" size="1080" />
      </video>
      } @else {
      <div [appStoryblok]="asset?._editable" class="asset-placeholder"></div>
      }
    </ng-template>
    <div class="teaser-content">
      @for (blok of content; track blok._uid) {
      <ndc-dynamic
        [ndcDynamicComponent]="$any(components[blok.component])"
        [ndcDynamicInputs]="$any(blok)"
      ></ndc-dynamic>
      } @if (cta && cta.link?.startsWith('/')) {
      <a class="primary-link with-arrow" animateInView="up" [routerLink]="cta.link" [appStoryblok]="cta._editable">
        {{ cta.text }}
      </a>
      } @if (cta && !cta.link?.startsWith('/')) {
      <a
        class="primary-link with-arrow"
        animateInView="up"
        [href]="cta.link"
        target="_blank"
        [appStoryblok]="cta._editable"
      >
        {{ cta.text }}
      </a>
      }
    </div>
  </div>
</app-block-wrapper>
